module.exports = __webpack_public_path__ + "img/2ezlogo.338188d0.svg";